import "../css/Menu.css";
import "animate.css";
import menuJSON from "../menu-list.json";
import MenuItem from "../pages/components/MenuItem";
import { useEffect } from "react";

function Menu() {
    return (
        <>
            <div className="flex flex-col w-full font-manrope">
                <div
                    className="w-full h-screen gap-3 mx-auto overflow-hidden bg-center bg-no-repeat bg-cover flex-cl "
                    style={{ backgroundImage: `url(./img/bg3.jpg)` }}
                >
                    <div
                        className="absolute top-0 bottom-0 left-0 right-0 w-full h-full overflow-hidden bg-fixed"
                        style={{ backgroundColor: `rgba(0,0,0,0.3)` }}
                    >
                        <div className="flex items-end justify-start w-full h-full text-white flex-start">
                            <h1
                                id="page-title"
                                className="relative w-4/6 pb-10 pl-10 pr-5 mb-10 text-6xl font-extrabold lg:w-1/2 md:pl-20 md:pr-10 md:text-9xl"
                            >
                                Our Menu
                            </h1>
                        </div>
                    </div>
                </div>
                <div
                    id="menu-container"
                    className="flex flex-row items-start w-full pt-20 pb-20"
                >
                    <div className="flex flex-col items-center justify-center h-full">
                        <div className="-mt-10 tracking-[4px] font-bold md:text-lg text-sm">
                            CATEGORIES
                        </div>
                        <ul
                            className="flex flex-col flex-wrap pl-0 mt-8 text-white list-none bg-gray-800 border-none shadow-md"
                            role="tablist"
                            data-te-nav-ref
                        >
                            <li
                                role="presentation"
                                className="flex-grow text-center"
                            >
                                <a
                                    href="#appetizer"
                                    className="my-2 md:w-[280px] w-40 block mt-0 mb-0 border-b-4 border-transparent pt-6 pb-6 text-sm md:text-lg font-medium uppercase leading-tight text-white hover:isolate hover:border-transparent hover:text-black hover:bg-white focus:isolate focus:bg-white focus:border-transparent focus:font-bold data-[te-nav-active]:font-bold data-[te-nav-active]:text-black data-[te-nav-active]:bg-white transition duration-50 data-[te-nav-active]:scale-110 data-[te-nav-active]:border-black border border-solid"
                                    data-te-toggle="pill"
                                    data-te-target="#appetizer"
                                    data-te-nav-active
                                    role="tab"
                                    aria-controls="appetizer"
                                    aria-selected="true"
                                >
                                    appetizer
                                </a>
                            </li>

                            <li
                                role="presentation"
                                className="flex-grow text-center"
                            >
                                <a
                                    href="#sandwich"
                                    className="focus:border-transparent md:w-[280px] w-40 my-2 mt-0 mb-0 border-b-4 block border-transparent pt-6 pb-6 text-sm md:text-lg font-medium uppercase leading-tight text-white hover:isolate hover:border-transparent hover:bg-white hover:text-black focus:isolate focus:font-bold data-[te-nav-active]:font-bold  data-[te-nav-active]:text-black data-[te-nav-active]:bg-white transition duration-100 data-[te-nav-active]:scale-110 data-[te-nav-active]:border-black border border-solid"
                                    data-te-toggle="pill"
                                    data-te-target="#sandwich"
                                    role="tab"
                                    aria-controls="sandwich"
                                    aria-selected="false"
                                >
                                    sandwich
                                </a>
                            </li>

                            <li
                                role="presentation"
                                className="flex-grow text-center"
                            >
                                <a
                                    href="#pho"
                                    className="focus:border-transparent md:w-[280px] w-40 my-2 mt-0 mb-0 block  border-b-4 border-transparent pt-6 pb-6 text-sm md:text-lg font-medium uppercase leading-tight text-white hover:isolate hover:border-transparent hover:bg-white hover:text-black focus:isolate focus:font-bold data-[te-nav-active]:font-bold  data-[te-nav-active]:text-black data-[te-nav-active]:bg-white transition ease-in data-[te-nav-active]:scale-110 data-[te-nav-active]:border-black border border-solid"
                                    data-te-toggle="pill"
                                    data-te-target="#pho"
                                    role="tab"
                                    aria-controls="pho"
                                    aria-selected="false"
                                >
                                    pho
                                </a>
                            </li>

                            <li
                                role="presentation"
                                className="flex-grow text-center"
                            >
                                <a
                                    href="#fried-rice"
                                    className="focus:border-transparent md:w-[280px] w-40 my-2 mt-0 mb-0 block  border-b-4 border-transparent pt-6 pb-6 text-sm md:text-lg font-medium uppercase leading-tight text-white hover:isolate hover:border-transparent hover:bg-white hover:text-black focus:isolate focus:font-bold data-[te-nav-active]:font-bold  data-[te-nav-active]:text-black data-[te-nav-active]:bg-white transition duration-50 data-[te-nav-active]:scale-110 data-[te-nav-active]:border-black border border-solid"
                                    data-te-toggle="pill"
                                    data-te-target="#fried-rice"
                                    role="tab"
                                    aria-controls="fried-rice"
                                    aria-selected="false"
                                >
                                    Fried Rice
                                </a>
                            </li>

                            <li
                                role="presentation"
                                className="flex-grow text-center"
                            >
                                <a
                                    href="#rice"
                                    className="my-2 block md:w-[280px] w-40 mt-0 mb-0 border-b-4 border-transparent pt-6 pb-6 text-sm md:text-lg font-medium uppercase leading-tight text-white hover:text-black hover:isolate hover:border-transparent hover:bg-white focus:isolate focus:border-transparent focus:font-bold data-[te-nav-active]:font-bold  data-[te-nav-active]:text-black data-[te-nav-active]:bg-white transition duration-50 data-[te-nav-active]:scale-110 data-[te-nav-active]:border-black border border-solid"
                                    data-te-toggle="pill"
                                    data-te-target="#rice"
                                    role="tab"
                                    aria-controls="rice"
                                    aria-selected="false"
                                >
                                    Rice
                                </a>
                            </li>

                            <li
                                role="presentation"
                                className="flex-grow text-center"
                            >
                                <a
                                    href="#vermicelli"
                                    className="my-2 block  md:w-[280px] w-40  mt-0 mb-0 border-b-4 border-transparent pt-6 pb-6 text-sm md:text-lg font-medium uppercase leading-tight text-white hover:text-black hover:isolate hover:border-transparent hover:bg-white focus:isolate focus:border-transparent focus:font-bold data-[te-nav-active]:font-bold  data-[te-nav-active]:text-black data-[te-nav-active]:bg-white transition duration-50 data-[te-nav-active]:scale-110 data-[te-nav-active]:border-black border border-solid"
                                    data-te-toggle="pill"
                                    data-te-target="#vermicelli"
                                    role="tab"
                                    aria-controls="vermicelli"
                                    aria-selected="false"
                                >
                                    Noodle Salad
                                </a>
                            </li>

                            <li
                                role="presentation"
                                className="flex-grow text-center"
                            >
                                <a
                                    href="#vegetarian"
                                    className="my-2 block md:w-[280px] w-40 mt-0 mb-0 border-b-4 border-transparent pt-6 pb-6 text-sm md:text-lg font-medium uppercase leading-tight text-white hover:text-black hover:isolate hover:border-transparent hover:bg-white focus:isolate focus:border-transparent focus:font-bold data-[te-nav-active]:font-bold  data-[te-nav-active]:text-black data-[te-nav-active]:bg-white transition duration-50 data-[te-nav-active]:scale-110 data-[te-nav-active]:border-black border border-solid"
                                    data-te-toggle="pill"
                                    data-te-target="#vegetarian"
                                    role="tab"
                                    aria-controls="vegetarian"
                                    aria-selected="false"
                                >
                                    vegetarian
                                </a>
                            </li>

                            <li
                                role="presentation"
                                className="flex-grow text-center"
                            >
                                <a
                                    href="#kids"
                                    className="my-2 block  md:w-[280px] w-40 mt-0 mb-0 border-b-4 border-transparent pt-6 pb-6 text-sm md:text-lg font-medium uppercase leading-tight text-white hover:text-black hover:isolate hover:border-transparent hover:bg-white focus:isolate focus:border-transparent focus:font-bold data-[te-nav-active]:font-bold  data-[te-nav-active]:text-black data-[te-nav-active]:bg-white transition duration-50 data-[te-nav-active]:scale-110 data-[te-nav-active]:border-black border border-solid"
                                    data-te-toggle="pill"
                                    data-te-target="#kids"
                                    role="tab"
                                    aria-controls="kids"
                                    aria-selected="false"
                                >
                                    kid's menu
                                </a>
                            </li>

                            <li
                                role="presentation"
                                className="flex-grow text-center"
                            >
                                <a
                                    href="#special"
                                    className="my-2 block md:w-[280px] w-40 mt-0 mb-0 border-b-4 border-transparent pt-6 pb-6 text-sm md:text-lg font-medium uppercase leading-tight text-white hover:text-black hover:isolate hover:border-transparent hover:bg-white focus:isolate focus:border-transparent focus:font-bold data-[te-nav-active]:font-bold  data-[te-nav-active]:text-black data-[te-nav-active]:bg-white transition duration-50 data-[te-nav-active]:scale-110 data-[te-nav-active]:border-black border border-solid"
                                    data-te-toggle="pill"
                                    data-te-target="#special"
                                    role="tab"
                                    aria-controls="special"
                                    aria-selected="false"
                                >
                                    special
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div
                        className="hidden flex-col justify-start px-5 h-full transition ease-in-out duration-200 data-[te-tab-active]:flex"
                        id="appetizer"
                        role="tabpanel"
                        aria-labelledby="appetizer"
                        data-te-tab-active
                    >
                        <h1
                            id="tab-title"
                            className="mb-5 text-xl text-center md:text-4xl h-fit"
                        >
                            APPETIZER - <i>MÓN KHAI VỊ</i>
                        </h1>
                        <MenuItem menu={menuJSON.menu[0].appetizer} />
                    </div>

                    <div
                        className="hidden flex-col justify-start px-5 h-full transition ease-in-out duration-200 data-[te-tab-active]:flex"
                        id="sandwich"
                        role="tabpanel"
                        aria-labelledby="sandwich"
                    >
                        <h1
                            id="tab-title"
                            className="text-xl md:text-4xl tracking-[4px] h-fit text-center"
                        >
                            SANDWICH - <i>BÁNH MÌ</i>
                        </h1>

                        <MenuItem menu={menuJSON.menu[1].sandwich} />
                    </div>

                    <div
                        className="hidden flex-col justify-start px-5 h-full transition ease-in-out duration-200 data-[te-tab-active]:flex"
                        id="pho"
                        role="tabpanel"
                        aria-labelledby="pho"
                    >
                        <h1
                            id="tab-title"
                            className="text-xl md:text-4xl tracking-[4px] h-fit text-center"
                        >
                            PHO NOODLE SOUP - <i>PHỞ</i>
                        </h1>
                        <p
                            id="tab-info"
                            className="pt-2 text-sm tracking-widest text-center md:text-lg h-fit"
                        >
                            Aromatic beef broth with fresh rice noodles topped
                            with white onion, green onion, cilantro, served with
                            a side of fresh herbs.
                        </p>
                        <MenuItem menu={menuJSON.menu[2].pho} />
                    </div>

                    <div
                        className="hidden flex-col justify-start px-5 h-full transition ease-in-out duration-200 data-[te-tab-active]:flex"
                        id="fried-rice"
                        role="tabpanel"
                        aria-labelledby="fried-rice"
                    >
                        <h1
                            id="tab-title"
                            className="text-xl md:text-4xl tracking-[4px] h-fit text-center"
                        >
                            FRIED RICE - <i>CƠM CHIÊN</i>
                        </h1>
                        <p
                            id="tab-info"
                            className="pt-2 text-sm tracking-widest text-center md:text-lg h-fit"
                        >
                            Fried rice served with side of lettuce, cucumber,
                            slide of tomato and soy sauce.
                        </p>
                        <MenuItem menu={menuJSON.menu[3]["fried-rice"]} />
                    </div>
                    <div
                        className="hidden flex-col justify-start px-5 h-full transition ease-in-out duration-200 data-[te-tab-active]:flex"
                        id="rice"
                        role="tabpanel"
                        aria-labelledby="rice"
                    >
                        <h1
                            id="tab-title"
                            className="text-xl md:text-4xl tracking-[4px] h-fit text-center"
                        >
                            RICE - <i>CƠM</i>
                        </h1>
                        <p
                            id="tab-info"
                            className="pt-2 text-sm tracking-widest text-center md:text-lg h-fit"
                        >
                            White rice served with side of lettuce, cucumber,
                            slide of tomato and fish sauce.
                        </p>

                        <MenuItem menu={menuJSON.menu[5].rice} />
                    </div>

                    <div
                        className="hidden flex-col justify-start px-5 h-full transition ease-in-out duration-200 data-[te-tab-active]:flex"
                        id="vermicelli"
                        role="tabpanel"
                        aria-labelledby="vermicelli"
                    >
                        <h1
                            id="tab-title"
                            className="text-xl md:text-4xl tracking-[4px] h-fit text-center"
                        >
                            NOODLE SALADS - <i>BÚN</i>
                        </h1>
                        <MenuItem menu={menuJSON.menu[4].vermicelli} />
                    </div>

                    <div
                        className="hidden flex-col w-full justify-start px-5 h-full transition ease-in-out duration-200 data-[te-tab-active]:flex"
                        id="vegetarian"
                        role="tabpanel"
                        aria-labelledby="vegetarian"
                    >
                        <h1
                            id="tab-title"
                            className="text-xl md:text-4xl tracking-[4px] h-fit text-center"
                        >
                            VEGETARIAN - <i>MÓN CHAY</i>
                        </h1>
                        <MenuItem menu={menuJSON.menu[6].vegetarian} />
                    </div>

                    <div
                        className="hidden w-full flex-col justify-start px-5 h-full transition ease-in-out duration-200 data-[te-tab-active]:flex"
                        id="kids"
                        role="tabpanel"
                        aria-labelledby="kids"
                    >
                        <h1
                            id="tab-title"
                            className="text-xl md:text-4xl tracking-[4px] h-fit text-center"
                        >
                            KID'S MENU
                        </h1>
                        <MenuItem menu={menuJSON.menu[7]["kids-menu"]} />
                    </div>

                    <div
                        className="hidden flex-col justify-start px-5 h-full transition ease-in-out duration-200 data-[te-tab-active]:flex"
                        id="special"
                        role="tabpanel"
                        aria-labelledby="special"
                    >
                        <h1
                            id="tab-title"
                            className="text-xl md:text-4xl tracking-[4px] h-fit text-center"
                        >
                            SPECIAL
                        </h1>
                        <MenuItem menu={menuJSON.menu[8].special} />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Menu;
